/**
 * IMPORTS
 */
import AxiosService from "@/infra/http/axios";
import { IRecepcaoRepository } from "@/interface/recepcao";

const recepcaoRepository: IRecepcaoRepository = {
  /**
   * Função para buscar remessas na recepcao
   * @param accessToken
   * @returns Promise<any | null>
   */
  async buscarRemessaEmRecepcao<T>(
    accessToken: string,
    currentPage: number = 1,
    itemsPerPage: number = 10,
    searchItem: ""
  ): Promise<T | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const expedicoes = await Instance.get(
      `remessas/tarefas-balcao?page=${currentPage}&per_page=${itemsPerPage}&search=${searchItem}`,
      {
        headers: {
          "content-type": "application/json; charset=UTF-8",
          accept: "*/*",
        },
      }
    );

    return expedicoes?.data;
  },
};

/**
 * EXPORTS
 */
export { recepcaoRepository };
